import { SxProps, Theme } from '@mui/material';

export const styles: Record<'icon' | 'textBox', SxProps<Theme>> = {
  icon: {
    minWidth: 48,
  },
  textBox: {
    backgroundColor: (theme) => theme.palette.gray[50],
    borderRadius: '10px',
    padding: (theme) => ({
      sm: theme.spacing(6),
      xxs: theme.spacing(2),
    }),
  },
};
